import {
  AfterContentChecked,
  AfterViewChecked,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {MessageContact} from "../../model/MessageContact";
import {APP_CHAT} from "../../model/MessageConstants";
import {MessageChat} from "../../model/MessageChat";
import {ChatMessageService} from "../../message.service";
import {MessageChatHolder} from "../../model/MessageHolder";
import {FileListComponent, FileListItem} from "../../filelist/list/file-list.component";
import {VideoConferenceService} from "../../video-conference.service";
import {LinkPreviewComponent, OpenGraphService} from '../../open-graph';
import {EnvelopBody} from "inet-core/src/websocket/websocket-abstract";

declare let iNet: any;

@Component({
  selector: 'message-chat',
  templateUrl: './message-chat.component.html',
  styleUrls: ['./message-chat.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MessageChatComponent implements OnInit, OnChanges, OnDestroy, AfterViewChecked, AfterContentChecked {
  @Input() username?: string;
  @Input() audioCall: boolean = false;
  @Input() videoCall: boolean = false;
  @Input() closable: boolean = false;
  @Output() onAudioCall = new EventEmitter<MessageContact>();
  @Output() onVideoCall = new EventEmitter<MessageContact>();
  @Output() onClose = new EventEmitter<MessageContact>();
  @ViewChild('input') input!: ElementRef;
  @ViewChild('messageBody') messageBody!: ElementRef;
  @ViewChild('fileList') fileList!: FileListComponent;
  @ViewChild(LinkPreviewComponent) linkPreview!: LinkPreviewComponent;
  videoPanelVisible: boolean = false;
  private linkRegex = /(https?:\/\/[^\s]+)/;
  contact?: MessageContact;
  holders: MessageChatHolder[] = [];
  files: any[] = [];
  filesSend: any[] = [];
  loading: boolean = true;
  profile = iNet.username;
  messageJoinCall: any = {};

  loadImage: boolean = false;
  imageShow: any;
  arrSendImage: any[] = [];
  defaultImage = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRhjZ2V8mB3dePikEX7_5QsM4s3WpDwj0ZvNg&usqp=CAU'

  get canSend(): boolean {
    return this.files.length > 0 || this.message.length > 0;
  }

  get message(): string {
    return this.input && this.input.nativeElement.value.trim() || '';
  }

  get scrollTop(): number {
    return this.messageBody.nativeElement.scrollTop;
  }

  set scrollTop(scrollTop: number) {
    this.messageBody.nativeElement.scrollTop = scrollTop;
  }

  get scrollHeight(): number {
    return this.messageBody.nativeElement.scrollHeight;
  }

  get scrollBottom(): number {
    return this.scrollHeight - this.messageBody.nativeElement.scrollTop;
  }

  set scrollBottom(scrollBottom: number) {
    this.scrollTop = this.scrollHeight - scrollBottom;
  }

  private _scrollingTop: boolean = false;
  private _scrollBottom: number = 0;
  private _lastScrollBottom: number = 0;
  private _scrollNeedUpdate: boolean = false;
  private _hasMoreMsg: boolean = false;
  private _messageObserver: any;
  private __messageChat: any;

  private _params: any = {
    pageSize: 20,
    pageNumber: 0
  };

  constructor(
    private openGraphService: OpenGraphService,
    private messageService: ChatMessageService,
    private videoService: VideoConferenceService,
    private element: ElementRef
  ) {
    this._messageObserver = this.messageService.messageReceived.subscribe((message: MessageChat) => {
      if (message.message.sender !== iNet.username) {
        if (message.message.sender === this.username) {
          if (message.message.message.alert) {
            let typeMessage = message.message.message.alert.split(":");
            if (typeMessage[0] === 'uri_message') {
              if (typeMessage[1] === 'video_conference' && !iNet.isEmpty(typeMessage[2])) {
                this.__messageChat = JSON.parse(this.decodeBase64(typeMessage[2])) || {};
                if (this.__messageChat.action === 'END') {
                  if (message.message.message.joins.split(',').length === 1) {
                    message.displayText = this.messageMissCall();
                    this._sendSuccess(message);
                  } else {
                    message.displayText = this.messageJoinedCall(message.message.message.duration);
                    this._sendSuccess(message);
                  }
                }
                if (this.__messageChat.action === 'LEFT' && message.message.message.joins.split(',')[0] === iNet.username) {
                  if (message.message.message.joins.split(',').length === 1) {
                    message.displayText = this.messageMissCall();
                    message.message.sender = message.message.message.joins.split(',')[0];
                    message.message.message.joins.split(',')[0] === iNet.username ? message.isSent = true : message.isSent = false;
                    this._sendSuccess(message);
                  } else {
                    message.displayText = this.messageJoinedCallTo(message.message.message.duration);
                    message.message.sender = message.message.message.joins.split(',')[0];
                    message.message.message.joins.split(',')[0] === iNet.username ? message.isSent = true : message.isSent = false;
                    this._sendSuccess(message);
                  }
                }
              }
            } else {
              this._sendSuccess(message);
            }
          }
        } else {
          if (this.username) {
            this.messageService.updateLastMessage(this.username, message.message);
            this.messageService.resetUnreadMessage(this.username);
          }
        }

      } else {
        let typeMessage = message.message.message.alert.split(":");
        if (typeMessage[0] === 'uri_message') {
          if (typeMessage[1] === 'video_conference' && !iNet.isEmpty(typeMessage[2])) {
            this.__messageChat = JSON.parse(this.decodeBase64(typeMessage[2])) || {};
            if (this.__messageChat.action === 'JOIN') {
            } else {
              if (this.__messageChat.action === 'LEFT') {
                this.videoService.dispose();
                const element = document.getElementById("meet");
                if (element) {
                  element.style.visibility = "hidden";
                }

                this._sendSuccess(message);
              }
            }
          }
        }
      }
      // if (message.message.sender === this.username) {
      // }
    });
    this.element.nativeElement.addEventListener('drop', (e: any) => {
      this.element.nativeElement.style.opacity = '1';
      this._onDropFile(e);
    });
    this.element.nativeElement.addEventListener('dragleave', (e: any) => {
      this.element.nativeElement.style.opacity = '1';
    });
    this.element.nativeElement.addEventListener('dragover', (e: any) => {
      this.element.nativeElement.style.opacity = '.5';
      e.preventDefault();
    });
  }

  private _onDropFile(ev: any) {
    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();
    let files;
    if (ev.dataTransfer.items) {
      files = [];
      // Use DataTransferItemList interface to access the file(s)
      for (var i = 0; i < ev.dataTransfer.items.length; i++) {
        // If dropped items aren't files, reject them
        if (ev.dataTransfer.items[i].kind === 'file') {
          files.push(ev.dataTransfer.items[i].getAsFile());
        }
      }
    } else {
      files = ev.dataTransfer.files;
    }
    if (files.length > 0) {
      this.fileList.addFiles(files);
    }
  }

  ngAfterContentChecked() {
    // Collect scroll position before render new messages
    if (this._scrollNeedUpdate) {
      this._lastScrollBottom = this.scrollBottom;
    }
  }

  ngAfterViewChecked() {
    // Restore scroll position after render new messages if not match
    if (this._scrollNeedUpdate) {
      let scrollBottom = this.scrollBottom;
      this._scrollNeedUpdate = false;
      if (this._lastScrollBottom != scrollBottom) {
        // Restore last scrollBottom
        this.scrollBottom = this._lastScrollBottom;
      }
    }
  }

  ngOnInit() {
    this._onLoad();
    // ifvisible.on("focus", () => {
    //     if (ifvisible.now()) {
    //         this._params.pageNumber = 0;
    //         this._onLoad();
    //         // this.messageService.reconnetSocket();
    //     }
    // });
    if (this.messageBody && this.messageBody.nativeElement) {
      this.messageBody.nativeElement.addEventListener('scroll', () => this._onBodyScroll());
      if (!this.videoService.isExistMeet()) {
        this.videoPanelVisible = false;
      }
    }

  }

  private _onBodyScroll() {
    const scrollBottom = this.scrollBottom;
    this._scrollingTop = this._scrollBottom <= scrollBottom;
    this._scrollBottom = scrollBottom;
    if (this.loading || !this._hasMoreMsg) {
      return;
    }
    // scroll to top
    if (this._scrollingTop && this.scrollTop < 150) {
      this._loadMessages();
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.username && !changes.username.firstChange) {
      this._onLoad();
      if (this.messageJoinCall) {
        this.messageJoinCall['joined'] = false;
      }
    }
  }

  ngOnDestroy() {
    this._messageObserver.unsubscribe();
  }

  viewAttachment(e: { file: FileListItem }) {
    window.open(e.file.url, '_blank');
  }

  sendMessage() {
    let value = this.message.trim();
    this.sendMessageSocket(value);
  }

  sendMessageSocket(value: string) {
    if (value || this.files.length > 0) {
      if (this.files.length > 0) {
        if (value == '') {
          value = this.files[0].name;
        }
        this._sendPush(value);
      } else {
        this._sendSocket(value);
      }
      this._clearInput();
    }
  }

  convertLinks(data: any, link: string) {
    let param: any = {};
    param['title'] = data['title'];
    param['image'] = data['image'];
    param['description'] = data['description'];
    param['url'] = link;
    let __host = new URL(link);
    param['finalUrl'] = __host.host.toUpperCase();
    return param;
  }

  private _loadMessages() {
    this.loading = true;
    this._hasMoreMsg = false;
    this.messageService.loadMessages(this._params, (result: any) => {
      // this.messages = result.items.concat(this.messages);
      this._addMessages(result.items);
      if (this._params.pageNumber === 0) {
        this._scrollToBottom();
      }
      this._scrollNeedUpdate = true;
      this._params.pageNumber += 1;
      this._hasMoreMsg = this._params.pageSize * this._params.pageNumber < result.total;
      setTimeout(() => {
        this.loading = false;
        this._onBodyScroll();
      }, 500);
    });
  }

  private _focus() {
    this.input.nativeElement.focus();
  }

  private _scrollToBottom() {
    setTimeout(() => {
      this.scrollTop = this.scrollHeight;
    }, 100);
  }

  private _clearInput() {
    this.files.length = 0;
    this.files = [];
    this.input.nativeElement.value = '';
    this._focus();
    this.fileList.removeAllFile(this.files);
  }

  private _addMessages(messagesArr: MessageChat[], insertLast: boolean = false) {
    let messages = this.convertArrayMessage(JSON.stringify(messagesArr));
    messages.sort((a: any, b: any) => b.date.getTime() - a.date.getTime());
    messages.forEach((message: any) => {
      let holder;
      // console.log('this.holders', this.holders)
      for (let i = 0; i < this.holders.length; i++) {
        if (this.holders[i].isSameDate(message.date)) {
          holder = this.holders[i];
          break;
        }
      }
      if (!holder) {
        holder = new MessageChatHolder(message.date);
        if (insertLast) {
          this.holders.push(holder);
        } else {
          this.holders.unshift(holder);
        }
      }
      if (insertLast) {
        holder.messages.push(message);
      } else {
        holder.messages.unshift(message);
      }
    });
  }


  private convertMessages(messages: any) {
    if (!iNet.isEmpty(messages)) {
      let __mes = this.messageService.revertMessage(messages.displayText) || '';
      let __mesDisplay = this.messageService.revertMessageDisplay(messages.displayText) || '';
      let typeMessages = __mes.split(":");
      if (typeMessages.length >= 2) {
        if (typeMessages[0] === 'uri_message' && typeMessages[1] === 'video_conference') {
          let __messageChat = JSON.parse(this.decodeBase64(typeMessages[2])) || {};
          if (messages.message.sender === this.username) {
            if (__messageChat.action === 'END') {
              if (messages.message.message.joins.split(',').length === 1) {
                messages.displayText = this.messageMissCall();
                return messages;
              } else {
                messages.displayText = this.messageJoinedCall(messages.message.message.duration);
                return messages;
              }
            }
            if (__messageChat.action === 'LEFT' && messages.message.message.joins.split(',')[0] === messages.message.sender) {
              if (messages.message.message.joins.split(',').length === 1) {
                messages.displayText = this.messageMissCall();
                return messages;
              } else {
                messages.displayText = this.messageJoinedCall(messages.message.message.duration);
                return messages;
              }
            } else {
              return messages;
            }

          } else {
            if (__messageChat.action === 'END') {
              if (messages.message.message.joins.split(',').length === 1) {
                messages.displayText = this.messageMissCall();
                return messages;
              } else {
                messages.displayText = this.messageJoinedCallTo(messages.message.message.duration);
                return messages;
              }
            } else {
              if (this.messageJoinCall['joined']) {
                messages.displayText = this.messageJoinedCallTo(messages.message.message.duration);
                return messages;
              } else {
                messages.displayText = this.messageMissCall();
                return messages;
              }
            }

          }
        } else {
          let links = this.linkRegex.exec(__mes);
          if (links && links.length > 0) {
            links.forEach(link => {
              if (this.openGraphService.isLink(link)) {
                this.openGraphService.loadPreviewLink(link, (grapData: any) => {
                  try {
                    messages['_openGraph'] = this.convertLinks(grapData, link);
                    messages.displayText = messages.displayText;
                    return messages;
                  } catch (e) {

                  }
                });
              }
            })
          } else {
            return messages;
          }

          // if (typeMessages[0] === 'uri_message' && typeMessages[1] === 'link_preview') {
          //     let __messageLink = JSON.parse(this.decodeBase64(typeMessages[2])) || {};
          //     messages['_openGraph'] = __messageLink;
          //     messages.displayText = __mesDisplay;
          //     return messages;
          // } else {
          return messages;
          // }
        }
      } else {
        return messages;
      }
    }
  }


  messageMissCall() {
    // $('.message-chat__miss').on('click',()=>{
    //     console.log('click')
    //     this.joinRoom(true);
    // })
    return '<div class="contact d-flex my-1" role="button" style="">\n' +
      '    <i class="message-chat__miss fa fa-phone ml-0"></i>\n' +
      '    <div class="contact-content pl-2">\n' +
      '        <div class="contact-name mb-1">Cuộc gọi bị nhỡ</div>\n' +
      '        <div class="contact-detail">Gọi lại</div>\n' +
      '    </div>\n' +
      '</div>'
  }

  messageJoinedCall(duration: any) {
    return '<div class="contact d-flex my-1" role="button" style="">\n' +
      '    <i class="message-chat__action fa fa-phone ml-0"></i>\n' +
      '    <div class="contact-content pl-2">\n' +
      '        <div class="contact-name mb-1">Cuộc gọi thoại đến</div>\n' +
      '        <div class="contact-detail">' + duration + ' giây' + '</div>\n' +
      '    </div>\n' +
      '</div>'
  }

  messageJoinedCallTo(duration: any) {
    return '<div class="contact d-flex my-1" role="button" style="">\n' +
      '    <i class="message-chat__action fa fa-phone ml-0"></i>\n' +
      '    <div class="contact-content pl-2">\n' +
      '        <div class="contact-name mb-1">Cuộc gọi thoại đi</div>\n' +
      '        <div class="contact-detail">' + duration + ' giây' + '</div>\n' +
      '    </div>\n' +
      '</div>'
  }

  private convertArrayMessage(arrMessage: any) {
    let arr = JSON.parse(arrMessage);
    arr.forEach((ele: any) => {
      ele = this.convertMessages(ele);
      ele.date = new Date(ele.date);
      return ele;
    });
    return arr;
  }

  encodeBase64(str: string) {
    return window.btoa(unescape(encodeURIComponent(str)));
  }

  decodeBase64(str: string) {
    return decodeURIComponent(escape(window.atob(str)));
  }

  private _onLoad() {
    this.disposeRoom();
    this._params.sender = this.username;
    this._params.pageNumber = 0;
    this._hasMoreMsg = false;
    this.holders = [];
    this.loading = true;
    this.files.length = 0;
    if (this.username) {
      this.messageService.getContactByUserCode(this.username, (contact: any) => this.contact = contact);
    }
    setTimeout(() => {
      this._loadMessages();
      this._focus();
    }, 500);
  }

  private _sendSocket(value: string) {
    if (this.username) {
      const envelop = this.messageService.buildEnvelop(this.username, value);
      this.messageService.sendEnvelop(envelop);
      this._sendSuccess(new MessageChat(envelop.body));
    }
  }

  removeFile(file: any) {
    this.files = findFileRemove(this.files, file);

    function findFileRemove(arrayFile: any[], item: any) {
      for (let i = 0; i < arrayFile.length; i++) {
        if (arrayFile[i] === item) {
          arrayFile.splice(i, 1);
        }
      }
      return arrayFile;
    }
  }

  removeAllFile(event: any) {
    if (this.files === event) {
      this.files = [];
    }
  }

  private _sendPush(value: string) {
    var params: any = {
      content: value,
      alert: value,
      application: APP_CHAT,
      alias: this.username,
    };
    this.files.forEach(function (file, i) {
      params['file-' + i] = file;
    });
    // console.log('params', params)
    this.messageService.pushMessage(params, (message: EnvelopBody) => {
      if (message) {
        this._sendSuccess(new MessageChat(message));
      }
    });
  }

  private _sendSuccess(message: MessageChat) {
    this._addMessages([this.convertMessages(message)], true);
    if (this.username) {
      this.messageService.updateLastMessage(this.username, message.message);
      this.messageService.resetUnreadMessage(this.username);
    }

    this._scrollToBottom();
  }

  joinRoom(audioOnly: boolean, usercode?: string) {
    this.videoPanelVisible = false;
    this.messageJoinCall['joined'] = false;
    if (!this.videoService.isExistMeet()) {
      this.messageJoinCall['joined'] = false;
      return;
    }
    const element = document.getElementById('meet');
    if (element) {
      element.style.visibility = "visible";
      let __user = '';
      if (!!usercode) {
        __user = usercode;
      } else if (this.contact) {

        __user = this.contact.usercode;
      }
      this.videoService.callTo(element, __user, audioOnly, 350, (api: any, messages: any) => {
        api.addEventListener('readyToClose', () => {
          this.videoService.dispose();
          element.style.visibility = "hidden";
          // this.messageService.sendEnvelop(envelop);
          if (!this.messageJoinCall['joined'] && this.username) {
            const envelop = this.messageService.buildEnvelop(this.username, messages);
            this._sendSuccess(new MessageChat(envelop.body));
          }
          // else{
          //     let __joins = [iNet.username,this.username];
          //     const envelop = this.messageService.buildEnvelop(this.username, messages,__joins.join(',') )
          //     console.log('envelop',envelop,__joins.join(','))
          //     this._sendSuccess(new MessageChat(envelop.body));
          // }
        });
        api.addEventListener('videoConferenceJoined', () => {
          this.messageJoinCall = this.videoService.getMessageJoin();
          this.messageJoinCall['joined'] = true;
        });
        api.executeCommand('toggleShareScreen');

      });
    }

  }

  disposeRoom() {
    this.videoPanelVisible = true;
    this.videoService.dispose();
  }

  showNameFileSend(data: any[]) {
    let dataResult: any[] = [];
    let fileName = '';
    dataResult = data.map((item: any) => item)
    dataResult = dataResult.slice(2, data.length);
    for (let i = 0; i < dataResult.length; i++) {
      if (fileName != '') {
        fileName = fileName + ', ' + '\n' + dataResult[i].name;
      } else {
        fileName = dataResult[i].name;
      }
    }
    return fileName;
  }

  arraySendImage(data: any) {
    const arrSendImage: any[] = [];
    if (data && data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].image === true) {
          arrSendImage.push(data[i]);
        }
      }
    }
    return arrSendImage
  }

  arraySendFile(data: any) {
    const arrSendFile: any[] = [];
    if (data && data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].image !== true) {
          arrSendFile.push(data[i]);
        }
      }
    }
    return arrSendFile
  }

  viewImage() {
    this.loadImage = !this.loadImage;
  }

  currentImage(image: any, data: any) {
    this.imageShow = image;
    this.arrSendImage = data.map((item: any) => item);
  }


  next(attachmentArr: any, image: any) {
    const index = attachmentArr.indexOf(image)
    if (index < attachmentArr.length - 1) {
      this.imageShow = attachmentArr[index + 1];
    } else if (index + 1 > attachmentArr.length - 1) {
      this.imageShow = attachmentArr[0];
    }
  }

  prev(attachmentArr: any, image: any) {
    const index = attachmentArr.indexOf(image)
    if (index === 0) {
      this.imageShow = attachmentArr[attachmentArr.length - 1];
    } else if (index > 0 && index <= attachmentArr.length - 1) {
      this.imageShow = attachmentArr[index - 1];
    }
  }
}
